@let post = data();
<pai-anchor-card
  [image]="post.image"
  [imageOptions]="imgOpts"
  [title]="post.title"
  [date]="date()"
  [text]="post.excerpt"
  [target]="target()"
  [preserveQueryParams]="true"
  ctaKey="CardProject.ReadMore"
  ctaIcon="chevron_right"
/>
